import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as moment from 'moment';
import { QuickbookNotificationService } from 'src/app/services/core/quickbook/notifications/quickbook-notification.service';
import { ToastService } from 'src/app/services/toast-service/toast.service';
import { QUICKBOOK_NOTIFICATION_ROUTES } from 'src/app/utils/notification-routes';

@UntilDestroy()
@Component({
  selector: 'app-quickbook-notification-modal',
  templateUrl: './quickbook-notification-modal.component.html',
  styleUrls: ['./quickbook-notification-modal.component.css']
})
export class QuickbookNotificationModalComponent implements OnInit {
  @Output() closeModal = new EventEmitter<void>();

  notifications: any[] = [];
  unreadCount = 0;

  constructor(
    private quickbookNotificationService: QuickbookNotificationService,
    private router: Router,
    private toastService: ToastService
  ) { }

  ngOnInit(): void {
    this.quickbookNotificationService.getUnreadCount()
      .pipe(untilDestroyed(this))
      .subscribe(count => this.unreadCount = count);

    this.quickbookNotificationService.refreshUnreadCount();
    this.getNotifications();
  }

  getNotifications() {
    this.quickbookNotificationService
      .getNotifications({ sortBy: 'createdAt:desc', time: [moment().startOf('day').toISOString(), moment().endOf('day').toISOString()] })
      .pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data) {
          this.notifications = data.results;
        }
      });
  }

  trackById(index: number, notification: any) {
    return notification.id || notification._id;
  }

  hasUnreadNotifications(): boolean {
    return this.notifications.some(n => !n.isRead);
  }

  onMarkAllAsRead() {
    this.quickbookNotificationService.markAllAsRead()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          this.notifications.forEach(n => n.isRead = true);
          this.quickbookNotificationService.setUnreadCount(0);
          this.toastService.show('All notifications marked as read.');
        },
        error: () => this.toastService.show('Failed to mark all as read.')
      });
  }

  onNotificationClick(notification: any) {
    this.markAsRead(notification);
    const route = QUICKBOOK_NOTIFICATION_ROUTES[notification?.type];
    if (route) {
      this.router.navigate([route]);
    }
    this.closeModal.emit();
  }

  onCloseModal() {
    this.closeModal.emit();
  }

  markAsRead(notification: any) {
    if (!notification || notification.isRead) return;
    notification.isRead = true;
    this.quickbookNotificationService.decrementUnreadCount(1);
    // not tied to untilDestroyed: the dropdown closes right after a click and must not cancel the request
    this.quickbookNotificationService.markAsRead(notification.id || notification._id).subscribe({ error: () => { } });
  }

  getRelativeTime(date: any): string {
    return date ? moment(date).fromNow() : '';
  }
}
